import * as angular from "angular";
import {IController} from "angular";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class ItineraryTasksActionMenuCtrl implements IController {

  disableClearAndCompleteActions: any;
  disableDropoffSelection: any;
  disablePickupSelection: any;
  disableOperationSelection: any;

  selectAllPickups: Function;
  selectAllDropoffs: Function;
  selectAllOperations: Function;
  clearAllSelectedTasks: Function;
  doCompleteSelectedTasks: Function;
  onOpen: Function;

  constructor(private confirmDialogService: ConfirmDialogService, private $log) {
  }

  onOpenSelection($mdMenu, event) {
    this.onOpen({$mdMenu: $mdMenu, event: event})
  }

  completeSelected(event) {
    const text = 'Are you sure you want to complete selected tasks?';
    this.confirmDialogService.confirm('Confirm Complete Tasks',text, event)
      .then(() => {
        this.doCompleteSelectedTasks();
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }
}

angular
  .module('bringoz.admin.agents')
  .component('itineraryTasksActionMenu', {
    bindings: {
      disableClearAndCompleteActions: '<',
      disableDropoffSelection: '<',
      disablePickupSelection: '<',
      disableOperationSelection: '<',
      selectAllPickups: '&',
      selectAllDropoffs: '&',
      selectAllOperations: '&',
      clearAllSelectedTasks: '&',
      doCompleteSelectedTasks: '&',
      onOpen: '&',
    },
    template: require('./itinerary-tasks-action-menu.html').default,
    controller: ItineraryTasksActionMenuCtrl
  });
